import { useEffect } from "react";

const SITE_URL = "https://theweddingphotographie.com";

/**
 * Sets document title, meta description, canonical link and Open Graph tags
 * for the current route (client-side, since this is a CSR React SPA).
 * Restores the previous values on unmount so navigating between pages
 * never leaves stale metadata behind.
 */
export const useSEO = ({ title, description, path }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const setMetaContent = (selector, value) => {
      const el = document.querySelector(selector);
      if (!el) return null;
      const prev = el.getAttribute("content");
      el.setAttribute("content", value);
      return prev;
    };

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalEl?.getAttribute("href") ?? null;
    canonicalEl?.setAttribute("href", `${SITE_URL}${path}`);

    const prevDescription = setMetaContent('meta[name="description"]', description);
    const prevOgTitle = setMetaContent('meta[property="og:title"]', title);
    const prevOgDescription = setMetaContent('meta[property="og:description"]', description);
    const prevOgUrl = setMetaContent('meta[property="og:url"]', `${SITE_URL}${path}`);

    return () => {
      document.title = prevTitle;
      if (prevCanonical !== null) canonicalEl?.setAttribute("href", prevCanonical);
      if (prevDescription !== null) document.querySelector('meta[name="description"]')?.setAttribute("content", prevDescription);
      if (prevOgTitle !== null) document.querySelector('meta[property="og:title"]')?.setAttribute("content", prevOgTitle);
      if (prevOgDescription !== null) document.querySelector('meta[property="og:description"]')?.setAttribute("content", prevOgDescription);
      if (prevOgUrl !== null) document.querySelector('meta[property="og:url"]')?.setAttribute("content", prevOgUrl);
    };
  }, [title, description, path]);
};
